import React from "react";
import Typography from "@material-ui/core/Typography";
const ExchangeRate = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Exchange Rate
      </Typography>
      <Typography paragraph variant="h5">
        Setup the exchange currency rates to base currency
      </Typography>
      <Typography paragraph variant="body1">
        Exchange Rate is one of the features under the Finance module to manage
        the exchange rate between foreign currency and base currency used by the
        company. It contains any information regarding the exchange currency
        conversion, exchange rate active duration, and the conversion rate.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Exchange Rate
        list. It is displayed like a table that contains download functions,
        sort, filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Exchange Rate</b>
        <br />
        Indicates the foreign currency to base currency of the Exchange Rate.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Valid From</b>
        <br />
        Indicates the active duration start date of the Exchange Rate.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Valid To</b>
        <br />
        Indicates the active duration end date of the Exchange Rate.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Exchange Rate Status</b>
        <br />
        Indicates the status of the Exchange Rate. There are 2 statuses: New
        Rate and Old Rate.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Exchange Rate To Base Currency</b>
        <br />
        Indicates the conversion rate of foreign currency to base currency.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Exchange Rate To Foreign Currency</b>
        <br />
        Indicates the conversion rate of base currency to foreign currency.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 2 buttons that appear on each row of Exchange Rate
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Exchange Rate</b>
        <br />
        This button is used to edit the Exchange Rate data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Exchange Rate</b>
        <br />
        This button is used to delete the Exchange Rate data. The Exchange Rate
        data is deletable, but we strongly recommend not deleting the old
        exchange rate for audit and history rate purposes.
      </Typography>
    </React.Fragment>
  );
};

export default ExchangeRate;
